module.exports = __webpack_public_path__ + "img/deco-22.587de333.png";